
import React, { Component } from 'react';
import { render } from 'react-dom';


class ProgressBar extends Component {

  constructor(props){
    super(props)
    
   
  }


  render(){
    return (
      
        <div  className={"progress-bar bg-"+this.props.color+` text+${this.props.color}`} 
             
               aria-valuenow={this.props.value} 
              aria-valuemin={0} 
              style={{width:this.props.value+"%"}}
              aria-valuemax={100} 
              
               
              >  &nbsp;  </div>
    )
  }
}

export default  ProgressBar;